import React, { useState, useEffect } from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';

// Import background images
import bg1 from '../../assets/backgrounds/1.png';
import bg2 from '../../assets/backgrounds/2.png';
import bg3 from '../../assets/backgrounds/3.png';
import bg4 from '../../assets/backgrounds/4.png';

const Hero = () => {
  const [backgroundImage, setBackgroundImage] = useState('');

  // Array of background images
  const backgroundImages = [bg1, bg2, bg3, bg4];

  useEffect(() => {
    // Select a random background image on component mount
    const randomIndex = Math.floor(Math.random() * backgroundImages.length);
    setBackgroundImage(backgroundImages[randomIndex]);
  }, []);

  return (
    <Box
      sx={{
        backgroundColor: '#e1e7f0',
        py: 6,
        textAlign: 'center',
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        minHeight: '275px',
        position: 'relative',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(225, 231, 240, 0.8)', // Semi-transparent overlay for readability
          zIndex: 1,
        },
      }}
    >
      <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 2 }}>
        <Typography
          variant="h4"
          component="h1"
          gutterBottom
          sx={{ fontWeight: 700, color: '#303236' }}
        >
          Home Improvement Starts Here
        </Typography>
        <Typography
          variant="h6"
          gutterBottom
          sx={{ color: '#505259', mb: 4 }}
        >
          Shop top brands for kitchen, bath, lighting and more
        </Typography>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            gap: 2,
            flexWrap: 'wrap',
          }}
        >
          <Button
            variant="contained"
            sx={{
              bgcolor: 'primary.main',
              '&:hover': { bgcolor: 'primary.dark' },
            }}
            size="large"
            component={Link}
            to="/category?Hardware"
          >
            Shop Hardware
          </Button>
          <Button
            variant="contained"
            sx={{
              bgcolor: 'primary.main',
              '&:hover': { bgcolor: 'primary.dark' },
            }}
            size="large"
            component={Link}
            to="/category?Flooring"
          >
            Shop Flooring
          </Button>
          <Button
            variant="contained"
            sx={{
              bgcolor: 'primary.main',
              '&:hover': { bgcolor: 'primary.dark' },
            }}
            size="large"
            component={Link}
            to="/category?Lighting"
          >
            Shop Lighting
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default Hero;
